<div class="modal-container">
  <!-- Sticky Header -->
  <div class="modal-header">
    <h2>Confluence import</h2>
  </div>

  <!-- Content Area -->
  <div class="modal-content">
    @if (!errorWhenFetching) {
      <div>
        @if (step === 'select') {
          <div>
            <div class="columns">
              <div>
                <h3 class="mat-h3">Spaces</h3>
                <div class="list-container">
                  @if (isProcessing.spaces) {
                    <app-spinner [message]="''" [small]="true"></app-spinner>
                  }
                  @if (!isProcessing.spaces) {
                    <div>
                      @if (spaces?.results?.length === 0 && !isProcessing.spaces) {
                        <p class="no-results">
                          No spaces
                        </p>
                      }
                      @for (space of spaces?.results; track space) {
                        <div
                          class="item"
                          [ngClass]="{ active: selectedSpace?.key === space.key }"
                          (click)="selectSpace(space)"
                          >
                          <span>{{ space.name }}</span>
                          <app-counter-badge
                            [tick]="isWholeSpaceSelected(space)"
                            [number]="countSelectedItems(space)"
                          ></app-counter-badge>
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="d-flex justify-content-between">
                  <button
                    (click)="toggleSelectWholeSpace()"
                    [disabled]="!selectedSpace || pages?.results?.length === 0 || isProcessing.pages"
                    color="accent"
                    mat-mini-fab
                    aria-label="Next"
                    >
                    <mat-icon>done_all</mat-icon>
                  </button>
                  <app-simple-paginator
                    (navChanged)="handlePageNavigationEvent('spaces', $event)"
                    [disable]="{ next: !!spaces?._links?.next, prev: !!spaces?._links?.prev }"
                  ></app-simple-paginator>
                </div>
              </div>
              <div>
                <h3 class="mat-h3">Pages</h3>
                <div
                  class="list-container"
                  [ngClass]="{ disabled: isWholeSpaceSelected(selectedSpace!) }"
                  >
                  @if (isProcessing.pages) {
                    <app-spinner [message]="''" [small]="true"></app-spinner>
                  }
                  @if (!isProcessing.pages) {
                    <div>
                      @if (pages === null) {
                        <p class="no-results">Space not selected</p>
                      }
                      @if (pages?.results?.length === 0 && !isProcessing.pages) {
                        <p class="no-results">
                          No pages
                        </p>
                      }
                      @for (page of pages?.results; track page) {
                        <p
                          class="item"
                          [ngClass]="{ active: isPageSelected(page) }"
                          (click)="togglePageSelection(page)"
                          >
                          {{ page.title }}
                        </p>
                      }
                    </div>
                  }
                </div>
                <app-simple-paginator
                  (navChanged)="handlePageNavigationEvent('pages', $event)"
                  [disable]="{ next: !!pages?._links?.next, prev: !!pages?._links?.prev }"
                ></app-simple-paginator>
              </div>
            </div>
            <div>
              <h3 class="mat-h3 m-t-24">Selected items</h3>
              <div class="list-container list-container__selected">
                @if (selected.pages.length === 0 && selected.spaces.length === 0) {
                  <p
                    class="no-results"
                    >
                    No items selected
                  </p>
                }
                @for (item of selected.spaces; track item) {
                  <div class="selected-item-list">
                    <mat-icon (click)="unselectSpace(item)">delete</mat-icon>
                    <p class="item">
                      <strong>{{ item.name }} </strong>
                    </p>
                  </div>
                }
                @for (item of selected.pages; track item) {
                  <div class="selected-item-list">
                    <mat-icon (click)="unselectPage(item)">delete</mat-icon>
                    <p class="item">
                      <strong>{{ item.space }} </strong>&nbsp;- {{ item.title }}
                    </p>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (step === 'create_folder') {
          <div>
            <app-source-folder-form
              [isDisabled]="isProcessing.posting"
              (formChange)="newFolderData = $event"
            ></app-source-folder-form>
          </div>
        }
      </div>
    } @else {
      <p>
        Can't connect to the Confluence API. Go to
        <span class="link" (click)="goToSettings()">API Settings</span> and verify credentials.
      </p>
    }

  </div>

  <!-- Bottom Sheet -->
  <div class="modal-footer">
    <div class="footer-actions">
      <div class="d-flex justify-content-between">
        <div>
          <button
            mat-raised-button
            color="accent"
            [disabled]="isProcessing.posting"
            (click)="dialogRef.close()"
            >
            Cancel
          </button>
          @if (step === 'create_folder') {
            <button
              mat-raised-button
              color="accent"
              (click)="step = 'select'"
              [disabled]="isProcessing.posting"
              >
              Previous
            </button>
          }
        </div>
        <div>
          <button
            style="align-self: flex-end"
            [disabled]="isNextDisabled()"
            mat-raised-button
            color="accent"
            (click)="goNext()"
            >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
